<template>
  <div>
    <img :src="imgPath" class="batchNum" style="width: 239px"/>
  </div>
</template>

<script>

export default {
  props: ["imgPath"],
  data() {
    return {
      lastImgPath: this.imgPath,
    };
  },
  watch: {
    imgPath: {
      handler(val) {
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.batchNum {
  width: 320px;
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/img/index.vue